import React, { useEffect, useState } from 'react';
import { useGetVolume } from 'containers/CahierJournal/queries/useGetVolume';
import RepartitionHoraire from '@teetsh/app/src/components/RepartitionHoraire';
import tw from 'twin.macro';
import { useTranslation } from 'react-i18next';
import DateInput2 from 'components/Form/Dateinput2';
import { UserLocale } from 'types/user';

interface Props {
  from: Date;
  to: Date;
}

function Repartition(props: { from: Date; to: Date }) {
  const { from, to } = props;
  const { data, isInitialLoading } = useGetVolume({ from, to });
  const groups = (data || []).map(d => ({
    id: d.id,
    name: d.name,
    items: d.tags.map(tag => ({
      id: tag.id,
      name: tag.name,
      color: tag.color,
      minutes: tag.volumeInMinutes,
    })),
  }));
  const { t } = useTranslation(['common', 'cahierJournal']);
  return (
    <div>
      {isInitialLoading ? (
        <div tw="p-3">
          <div tw="h-4 mb-2" className="tsh-skeleton" />
          <div tw="space-y-1">
            <div tw="h-4" className="tsh-skeleton" />
            <div tw="h-4" className="tsh-skeleton" />
            <div tw="h-4" className="tsh-skeleton" />
          </div>
        </div>
      ) : (
        <div tw="px-3">
          {groups.length > 0 ? (
            <RepartitionHoraire groups={groups}>
              {({ total }) => (
                <div tw="flex justify-between mt-4 bg-neutral-supershy p-3 -mx-3">
                  <div tw="text-muted">
                    {t('cahierJournal:toolbar.volume.total')}
                  </div>
                  <div css={[tw`font-bold text-base`]}>{total}</div>
                </div>
              )}
            </RepartitionHoraire>
          ) : (
            <div tw="pt-5 pb-5 text-center text-muted">
              {t('cahierJournal:toolbar.volume.noData')}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export function Body(props: Props) {
  const [dates, setDates] = useState<{
    from: Date;
    to: Date;
  }>({ from: props.from, to: props.to });
  useEffect(() => {
    if (props.from !== dates.from || props.to !== dates.to) {
      setDates({ from: props.from, to: props.to });
    }
  }, [props.from, props.to]);
  const { t } = useTranslation(['common', 'cahierJournal']);
  return (
    <>
      <div tw="flex gap-x-4 px-3">
        <div onClick={e => e.stopPropagation()} tw="w-28">
          <DateInput2
            userLocale={t('common:locale.long') as UserLocale}
            portal
            id="from"
            label={t('cahierJournal:toolbar.volume.from')}
            onChange={from => {
              if (!from) {
                return;
              }
              setDates({ ...dates, from });
            }}
            value={dates.from}
          />
        </div>
        <div tw="w-28">
          <DateInput2
            userLocale={t('common:locale.long') as UserLocale}
            portal
            id="to"
            label={t('cahierJournal:toolbar.volume.to')}
            onChange={to => {
              if (!to) {
                return;
              }
              setDates({ ...dates, to });
            }}
            value={dates.to}
          />
        </div>
      </div>
      <Repartition from={dates.from} to={dates.to} />
    </>
  );
}
